import Header from "../components/molecule/header";
import Footer from "../components/molecule/footer";
import { Outlet } from "react-router";
import { useEffect, useState } from "react";

const pageMenuOptions = {
    1: [
        {
            label: "Página Inicial",
            path: "/#first",
        },
        {
            label: "Sobre",
            path: "/#third",
        },
        {
            label: "Projetos",
            options: [
                {
                    label: "Memórias da Alma",
                    path: "/memorias-da-alma/#first",
                },
            ]
        },
    ],
    2: [
        {
            label: "Página Inicial",
            path: "/#first",
        },
        {
            label: "Arquivo vivo",
            path: "/memorias-da-alma/oculto/home",
            options: [
                {
                    label: "Início",
                    path: "/memorias-da-alma/oculto/home/#first",
                },
                {
                    label: "O romance",
                    path: "/memorias-da-alma/oculto/home/#romance",
                },
                {
                    label: "A reflexão espiritual",
                    path: "/memorias-da-alma/oculto/home/#reflexao",
                },
                {
                    label: "A condição humana",
                    path: "/memorias-da-alma/oculto/home/#humana",
                }, 
                {
                    label: "A filosofia do amor",
                    path: "/memorias-da-alma/oculto/home/#filosofia",
                },
                {
                    label: "A arte como vestígio da alma",
                    path: "/memorias-da-alma/oculto/home/#arte",
                },
                {
                    label: "A leitura psicológica",
                    path: "/memorias-da-alma/oculto/home/#leitura",
                }, 
                // {
                //     label: "Carta da autora",
                //     path: "/memorias-da-alma/oculto/home/#carta",
                // }
            ]
        },
        {
            label: "Símbolos",
            path: "/memorias-da-alma/oculto/simbolos",
            options: [
                {
                    label: "Início",
                    path: "/memorias-da-alma/oculto/simbolos/#first",
                },
                {
                    label: "As flores",
                    path: "/memorias-da-alma/oculto/simbolos/#flores",
                },
                {
                    label: "A estação",
                    path: "/memorias-da-alma/oculto/simbolos/#estacao",
                },
                {
                    label: "O relógio",
                    path: "/memorias-da-alma/oculto/simbolos/#relogio",
                },
                {
                    label: "A casa",
                    path: "/memorias-da-alma/oculto/simbolos/#casa",
                },
                {
                    label: "As estrelas",
                    path: "/memorias-da-alma/oculto/simbolos/#estrelas",
                },
                {
                    label: "As portas",
                    path: "/memorias-da-alma/oculto/simbolos/#portas",
                },
                {
                    label: "A saudade",
                    path: "/memorias-da-alma/oculto/simbolos/#saudade",
                },
            ]
        },
        {
            label: "Vestígio",
            path: "/memorias-da-alma/oculto/vestigio/#first",
        },
        {
            label: "Projetos",
            options: [
                {
                    label: "Memórias da Alma",
                    path: "/memorias-da-alma/#first",
                },
            ]
        },
    ]
};

const PageLayout = () => {

    const [menuIndex, setMenuIndex] = useState(1);

    useEffect(() => {
        if(window.location.pathname.includes('/memorias-da-alma/oculto')){
            setMenuIndex(2);
        } else {
            setMenuIndex(1);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(<>
        <Header buttons={pageMenuOptions[menuIndex]} dark={menuIndex === 2}/>
            <Outlet />
        <Footer />
    </>)

}

export default PageLayout;